export class DashboardFilterModel {
}
